module.exports = __webpack_public_path__ + "static/media/2.c9fa4b62.jpg";